<template>
  <footer class="site-footer column-gap-8">
    <div>Copyright GridUnity {{ thisYear() }} - All Rights Reserved</div>
    <a href="https://gridunity.com/terms-of-use/">Terms of Use</a>
    <a href="https://gridunity.com/privacy-policy/">Privacy Policy</a>
  </footer>
</template>

<script setup>
import { thisYear } from '@shared/utils/date'
</script>
